import { useEffect, useState } from "react";
import PubSub from "../../services/PubSub";
import { Toast, ToastContainer } from "react-bootstrap";
import { useTranslation } from "react-i18next";

const Spinner = () => {
    const [show, setShow] = useState(false);
    const [translate] = useTranslation();

    useEffect(() => {
        const showId = PubSub.subscribe("show_spinner", () => setShow(true));
        const hideId = PubSub.subscribe("hide_spinner", () => setShow(false));

        return () => {
            PubSub.unsubscribe("show_spinner", showId);
            PubSub.unsubscribe("hide_spinner", hideId);
        }
    }, []);

    return (
        <ToastContainer className="p-3 top-most" position="bottom-end">
            <Toast
                show={show}
                animation={false}
                bg="light"
                key="loading-toast"
                className="border-secondary">
                <Toast.Body>
                    <div className="d-flex align-items-center">
                        <div className="spinner-border spinner-border-sm text-secondary" />
                        <label className="d-block ms-3 fw-bold text-secondary">{translate("OTM_LOADING")}</label>
                    </div>
                </Toast.Body>
            </Toast>
        </ToastContainer>
    );
};

export default Spinner;